// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import individualDiagnose from "../../../share/util/individualDiagnose";
import resourceMap from "../../../share/util/resourceMap";

export default {
    name: "individualFunctions",

    /**
     * データの初期化を行う
     * @returns 初期化したデータ
     */
    data() {
        return {
            // noop
        };
    },

    components: {
        // noop
    },

    watch: {
        // noop
    },

    computed: {
        /**
         * システム用のリソースキーを取得する
         * @returns リソースキー
         */
        getSystemResourceKey() {
            const selectedSystemId = individualDiagnose.getCurrentSystemId(this);
            return resourceMap.getResourceKeyForDiagSystem(selectedSystemId);
        },
    },

    methods: {
        // noop
    },

    /**
     * コンポーネント生成時に呼ばれるイベント
     */
    created() {
        // noop
    },

    /**
     * DOM 生成後に呼ばれるイベント
     */
    mounted() {
        this.$emit("setVehicleTabsAvailable", true);
    },
};
